import React from 'react';

import { StartFreeTrialButton } from '../StartFreeTrialButton';

interface Props {
  href: string;
  loading?: boolean;
  className?: string;
}

export const StartButton: React.FC<Props> = ({ href, loading = false, className = '' }) => {
  const isSignupUrlInvalid = href === '';

  return (
    <StartFreeTrialButton
      disabled={isSignupUrlInvalid}
      href={href}
      showSpinner={loading}
      className={className}
    />
  );
};
